import { render, staticRenderFns } from "./grid-actions.vue?vue&type=template&id=8b2a7194"
import script from "./grid-actions.ts?vue&type=script&lang=js&external"
export * from "./grid-actions.ts?vue&type=script&lang=js&external"
import style0 from "./grid-actions.vue?vue&type=style&index=0&id=8b2a7194&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports